import React, { useEffect, useState } from 'react'
import { useCandidate } from './CandidateProvider'
import {
  FollowUpModal,
  IgnoreTaskModal,
} from '../CoachDashboard/FollowUpModals'
import moment from 'moment'

const StaleText = ({ serviceRequest }) => {
  const { detailItemId, candidateFirstName, coachFirstName } = useCandidate()
  const [isStale, setIsStale] = useState(false)

  useEffect(() => {
    setIsStale(
      serviceRequest?.coachNextTask === 'Send Follow-Up Message' &&
        moment(serviceRequest?.dueAt).isSameOrBefore(moment(), 'day'),
    )
  }, [serviceRequest])
  const [ignoreTaskModalOpen, setIgnoreTaskModalOpen] = useState(false)
  const [followUpModalOpen, setFollowUpModalOpen] = useState(false)
  const onSuccess = () => setIsStale(false)
  if (!isStale) return null
  return (
    <div className="font-sm text-medium max-w-max rounded-lg px-4 py-2">
      <span className="text-intoo-red-destructive">
        This candidate appears to have gone stale.{' '}
      </span>
      <span>
        <a
          className={'cursor-pointer'}
          onClick={() => setFollowUpModalOpen(true)}
          title={'Send Follow-Up Message'}
        >
          Send Follow-Up
        </a>
      </span>
      {' | '}
      <span>
        <a
          className={'cursor-pointer'}
          title={'Ignore follow-up task'}
          onClick={() => setIgnoreTaskModalOpen(true)}
        >
          Ignore
        </a>
      </span>
      <FollowUpModal
        modalOpen={followUpModalOpen}
        setModalOpen={setFollowUpModalOpen}
        serviceRequest={serviceRequest}
        onSuccess={onSuccess}
        candidateFirstName={candidateFirstName}
        coachFirstName={coachFirstName}
      />
      <IgnoreTaskModal
        modalOpen={ignoreTaskModalOpen}
        setModalOpen={setIgnoreTaskModalOpen}
        serviceRequestId={detailItemId}
        url={''}
      />
    </div>
  )
}

export default StaleText
